import { PermissionUser } from "../permission-user"

export const menuOptions = [
  {
    id: 1,
    name: "Ticket Management",
    permission: PermissionUser.WPM.REPORT_TICKET_READ,
  },
  {
    id: 2,
    name: "Site Access",
    permission: PermissionUser.WPM.REPORT_SITE_ACCESS_READ,
  },
  // { id: 3, name: "Smart Hand" },
  // { id: 4, name: "Cross Connect" },
  // { id: 5, name: "Parcel Tracking" },
  // { id: 6, name: "Inventory" },
  {
    id: 7,
    name: "NTDC Database (Contract)",
    permission: PermissionUser.WPM.REPORT_NTDC_CONTRACT_READ,
  },
  {
    id: 8,
    name: "IP Address Management",
    permission: PermissionUser.WPM.REPORT_IPAM_READ,
  },
  // { id: 8, name: "IDC Database (Customer)" },
  // { id: 9, name: "IDC Database (Contact Point & Sale)" },
  {
    id: 10,
    name: "Workload",
    permission: PermissionUser.WPM.REPORT_WORKLOAD_READ,
  },
]

export const workloadUserScopeOptions = [
  {
    name: "All Users",
    value: "ALL_USERS",
    permission: PermissionUser.WPM.WORKLOAD_ALL_USERS_READ,
  },
  {
    name: "Only Me",
    value: "ONLY_ME",
    permission: PermissionUser.WPM.REPORT_WORKLOAD_READ,
  },
]
